import { Tooltip } from '@ipfabric/ui-components/Tooltip/Tooltip';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import classNames from 'classnames';
import { pipe } from 'fp-ts/lib/function';
import type { FC } from 'react';
import type { JSX, SVGProps } from 'react';

interface Props extends Omit<SVGProps<SVGSVGElement>, 'xmlns'> {
  className?: string;
  disabled?: boolean;
  onClick?: () => void;
  title?: string;
  disabledTitle?: string;
}

function getTitle(props: Props): string | undefined {
  return props.disabled ? props.disabledTitle || props.title : props.title;
}

const wrapWithTooltip =
  (title?: string) =>
  (button: JSX.Element): JSX.Element =>
    title ? (
      <Tooltip content={title} placement='left'>
        {button}
      </Tooltip>
    ) : (
      button
    );

export const GraphToolbarButton: FC<Props> = (props) => {
  const handleClick = useStableCallback(() => {
    if (!props.disabled) {
      props.onClick?.();
    }
  });

  const title = getTitle(props);

  return pipe(
    <div
      className={classNames(
        'graph-toolbar__button',
        props.className,
        !props.disabled && 'svgicon__hover-container',
        props.disabled && 'graph-toolbar__button--disabled',
      )}
      onClick={handleClick}
    >
      {props.children}
    </div>,
    wrapWithTooltip(title),
  );
};
